import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * ECDEV-174: the "print layout" switch shared by the Stage-3 approval preview and the Stage-4
 * document preview. ON renders the pre-printed form background behind the typed values; OFF renders
 * the values only, on blank pages, for printing onto pre-printed stock.
 *
 * Purely presentational: the host owns the value and persists it through
 * DocumentPrintPreferenceService. Its only job is to keep the label, tooltip, test id and styling
 * identical in both modals.
 */
@Component({
  selector: 'app-print-layout-toggle',
  templateUrl: './print-layout-toggle.component.html',
  styleUrls: ['./print-layout-toggle.component.scss'],
})
export class PrintLayoutToggleComponent {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() testId = 'print-layout-toggle';
  @Output() checkedChange = new EventEmitter<boolean>();
}
